<div class="timing-tower-container" [class.full-timing-mode]="config().enableDrawer">
	@if (teams().length === 0) {
		<div class="h-full flex justify-center align-center px-8 py-40">
			<span>No Active Standing Entries</span>
		</div>
	} @else {
		<table class="timing-table table-auto w-full">
			<thead class="bg-surface-container text-on-surface-container text-xs sticky top-0">
				<tr
					cdkDropList
					cdkDropListOrientation="horizontal"
					(cdkDropListDropped)="onHeaderDrop($event)"
				>
					@for (column of visibleColumns(); track column.id) {
						<th
							cdkDrag
							[class]="column.headerClass || ''"
							[ngClass]="getAlignmentClass(column.alignment)"
							class="draggable-header"
						>
							<div class="header-content" cdkDragHandle>
								{{ column.label || '' }}
							</div>
						</th>
					}
					@if (enableColumnCustomization() && config().enableDrawer) {
						<th class="column-settings-header">
							<button
								type="button"
								class="column-settings-btn"
								(click)="openColumnSettings(); $event.stopPropagation()"
								aria-label="Column Settings"
								title="Show/Hide Columns"
							>
								<i class="bi bi-sliders"></i>
							</button>
							@if (isColumnSettingsOpen()) {
								<div class="column-dropdown" (click)="$event.stopPropagation()">
									<div class="dropdown-header">
										<span>Show/Hide Columns</span>
										<button
											class="close-btn"
											(click)="closeColumnSettings(); $event.stopPropagation()"
											type="button"
										>
											<i class="bi bi-x"></i>
										</button>
									</div>
									<div class="dropdown-body">
										@for (column of currentConfig().columns; track column.id) {
											@if (column.id !== 'positionArrow') {
												<label class="column-checkbox-item">
													<input
														type="checkbox"
														[checked]="column.visible"
														(change)="toggleColumnVisibility(column.id)"
													/>
													<span>{{ getColumnLabel(column) }}</span>
												</label>
											}
										}
									</div>
									<div class="dropdown-actions">
										<button class="btn-reset-small" (click)="resetColumns()" type="button">
											Reset
										</button>
									</div>
								</div>
							}
						</th>
					}
				</tr>
			</thead>
			<tbody class="text-sm">
				<ng-container *ngFor="let team of teams(); trackBy: trackByFn">
					<tr
						class="hover:bg-surface-container-high"
						[class.team-row-moved-up]="positionChangeStateByNumber()[team?.number ?? ''] === 'up'"
						[class.team-row-moved-down]="
							positionChangeStateByNumber()[team?.number ?? ''] === 'down'
						"
						[ngClass]="timingTowerService.activeList().includes(team?.number) ? activeClass() : ''"
						[class.is-selected]="timingTowerService.activeList().includes(team?.number)"
						[style.background-color]="
							timingTowerService.activeList().includes(team?.number)
								? 'rgba(229, 57, 53, 0.14)'
								: null
						"
						[style.color]="
							timingTowerService.activeList().includes(team?.number)
								? 'var(--on-surface-container)'
								: null
						"
						[class.has-playback]="team?.playback?.url"
						(click)="toggleTeamSelection(team!)"
					>
						@for (column of visibleColumns(); track column.id) {
							<td [class]="column.cellClass || ''" [ngClass]="getAlignmentClass(column.alignment)">
								<!-- Details Toggle Button -->
								@if (column.id === 'detailsToggle') {
									<button
										type="button"
										class="details-toggle-btn"
										(click)="toggleDrawer(team, $event)"
										aria-label="Toggle team details"
										[attr.aria-expanded]="isDrawerOpen(team)"
									>
										<i class="bi" [ngClass]="isDrawerOpen(team) ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
									</button>
								}

								<!-- Position Arrow & Favorite Star -->
								@if (column.id === 'positionArrow') {
									<vb-lxp-position-change-indicator
										[state]="positionChangeStateByNumber()[team?.number ?? ''] || 'neutral'"
									></vb-lxp-position-change-indicator>
									@if (
										config().enableFavoriteDriver &&
										positionChangeStateByNumber()[team?.number ?? ''] === 'neutral'
									) {
										<button>
											<i
												class="bi"
												(click)="toggleFavoriteDriver(team)"
												[ngClass]="
													favoriteDriverService.isFavoriteDriver(team) ? 'bi-star-fill' : 'bi-star'
												"
											></i>
										</button>
									}
								}

								<!-- Position -->
								@if (column.id === 'position') {
									<span
										class="timing-position-value"
										[ngClass]="
											timingTowerService.activeList().includes(team?.number)
												? activeNumberClass()
												: ''
										"
									>
										{{ team?.activeStanding?.position }}
									</span>
								}

								<!-- Car Number -->
								@if (column.id === 'carNumber') {
									<div
										class="rounded-sm flex items-center justify-center"
										[class.px-1]="!column.cellClass?.includes('car-info')"
										[title]="team?.class"
										[style.background-color]="team?.classDetails?.background"
										[style.color]="team?.classDetails?.foreground"
									>
										<span>{{ team?.number }}</span>
									</div>
								}

								@if (column.id === 'carLogo') {
									<img
										class="w-6 h-6 object-contain"
										[src]="team?.manufacturer || team?.vehicle || '' | teamLogoLookup: team?.class"
										alt="Logo"
										[title]="team?.manufacturer || team?.vehicle"
									/>
								}

								<!-- Team/Driver -->
								@if (column.id === 'teamDriver') {
									<div class="flex items-center gap-1">
										<div class="flex flex-col">
											<div class="team-driver-line">
												<span class="flex timing-driver-name">
													<span class="timing-driver-text">{{ team?.currentDriverFullName }}</span>
												</span>
											</div>
											<div
												class="team-name"
												[style.font-size]="config().enableDrawer ? '' : '10px'"
											>
												{{ team?.team }}
											</div>
										</div>
										@if (team?.playback?.url && !config().enableDrawer) {
											<i class="text-primary bi bi-play-circle timing-play-icon"></i>
										}
									</div>
								}

								<!-- Class Position (Pic) -->
								@if (column.id === 'classPosition') {
									{{ team?.classStanding?.position }}
								}

								<!-- Lap -->
								@if (column.id === 'lap') {
									{{ team?.participantDetails?.currentLap }}
								}

								<!-- Gap -->
								@if (column.id === 'gap') {
									<span class="timing-data-bold">
										@if (team?.activeStanding?.gapFirstLaps > 0) {
											{{ team?.activeStanding?.gapFirstLaps }}L
										} @else {
											+{{
												team?.activeStanding?.gapFirstTime
													? (team?.activeStanding?.gapFirstTime || 0 | timespanShort)
													: '0.000'
											}}
										}
									</span>
								}

								<!-- Class Gap -->
								@if (column.id === 'classGap') {
									<span class="timing-data-bold">
										@if (team?.classStanding?.gapFirstLaps > 0) {
											{{ team?.classStanding?.gapFirstLaps }}L
										} @else {
											+{{
												team?.classStanding?.gapFirstTime
													? (team?.classStanding?.gapFirstTime || 0 | timespanShort)
													: '0.000'
											}}
										}
									</span>
								}

								<!-- Interval -->
								@if (column.id === 'interval') {
									<span class="timing-data-bold">
										@if (team?.activeStanding?.gapPreviousLaps > 0) {
											{{ team?.activeStanding?.gapPreviousLaps }}L
										} @else {
											+{{
												team?.activeStanding?.gapPreviousTime
													? (team?.activeStanding?.gapPreviousTime || 0 | timespanShort)
													: '0.000'
											}}
										}
									</span>
								}

								<!-- Last Lap -->
								@if (column.id === 'lastLap') {
									<span class="timing-data-bold timing-last-lap">
										@if (team?.participantDetails?.lastLap?.time) {
											<span [ngClass]="team?.lastLapClass">
												{{ team?.participantDetails?.lastLap?.time | timespanMs }}
											</span>
										} @else {
											<span>--</span>
										}
									</span>
								}

								<!-- Best Lap -->
								@if (column.id === 'bestLap') {
									<span class="timing-data-bold">
										@if (team?.participantDetails?.bestLap?.time) {
											<span>{{ team?.participantDetails?.bestLap?.time | timespanMs }}</span>
										} @else {
											<span>--</span>
										}
									</span>
								}

								<!-- Sector 1 -->
								@if (column.id === 'sector1') {
									<span class="timing-data-bold">
										@if (team?.currentLapSectorData[1]) {
											<span [ngClass]="team?.currentLapSectorData[1].className">
												{{ team?.currentLapSectorData[1].time | timespanShort }}
											</span>
										} @else {
											<span>--</span>
										}
									</span>
								}

								<!-- Sector 2 -->
								@if (column.id === 'sector2') {
									<span class="timing-data-bold">
										@if (team?.currentLapSectorData[2]) {
											<span [ngClass]="team?.currentLapSectorData[2].className">
												{{ team?.currentLapSectorData[2].time | timespanShort }}
											</span>
										} @else {
											<span>--</span>
										}
									</span>
								}

								<!-- Sector 3 -->
								@if (column.id === 'sector3') {
									<span class="timing-data-bold">
										@if (team?.currentLapSectorData[3]) {
											<span [ngClass]="team?.currentLapSectorData[3].className">
												{{ team?.currentLapSectorData[3].time | timespanShort }}
											</span>
										} @else {
											<span>--</span>
										}
									</span>
								}

								<!-- Pits -->
								@if (column.id === 'pits') {
									{{ team.participantDetails?.pitStops }}
								}

								@if (column.id === 'lsp') {
									{{ team.lapsSincePit }}
								}

								<!-- Max Speed -->
								@if (column.id === 'maxSpeed') {
									<span [class.text-secondary]="team.isTopSpeedOverall">
										{{ team.participantDetails?.bestTopSpeed * 0.621371 | number: '1.1-1' }}
										@if (team.participantDetails?.bestTopSpeed) {
											mph
										} @else {
											--
										}
									</span>
								}
							</td>
						}
						@if (enableColumnCustomization() && config().enableDrawer) {
							<td class="column-settings-cell"></td>
						}
					</tr>

					@if (config().enableDrawer) {
						<tr class="drawer-row" [class.is-open]="isDrawerOpen(team)">
							<td [attr.colspan]="drawerColspan">
								<vb-lxp-timing-tower-drawer
									[team]="team"
									[isOpen]="isDrawerOpen(team)"
								></vb-lxp-timing-tower-drawer>
							</td>
						</tr>
					}
				</ng-container>
			</tbody>
		</table>
		
		@if (isColumnSettingsOpen() && enableColumnCustomization() && !hideColumnSelection()) {
			<div class="column-dropdown-overlay" (click)="$event.stopPropagation()">
				<div class="dropdown-header">
					<span>Show/Hide Columns</span>
					<button
						class="close-btn"
						(click)="closeColumnSettings(); $event.stopPropagation()"
						type="button"
					>
						<i class="bi bi-x"></i>
					</button>
				</div>
				<div class="dropdown-body">
					@for (column of currentConfig().columns; track column.id) {
						@if (column.id !== 'positionArrow') {
							<label class="column-checkbox-item">
								<input
									type="checkbox"
									[checked]="column.visible"
									(change)="toggleColumnVisibility(column.id)"
								/>
								<span>{{ getColumnLabel(column) }}</span>
							</label>
						}
					}
				</div>
				<div class="dropdown-actions">
					<button class="btn-reset-small" (click)="resetColumns()" type="button">
						Reset
					</button>
				</div>
			</div>
		}
	}
</div>
